// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div[data-v-0906c7a6]{box-sizing:border-box;padding:1rem;z-index:1}[data-v-0906c7a6] body.oax-detailmap-visible header{display:none}[data-v-0906c7a6] .oax .oax_singleView_wrapper.oax_with_ep{margin-bottom:5rem}[data-v-0906c7a6] .leaflet-right .leaflet-control-zoom.leaflet-bar.leaflet-control{margin-top:3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
